import React, { CSSProperties, FC, ReactNode, useEffect, useRef } from 'react';
import clsx from 'clsx';
import { Layout } from 'react-grid-layout';
import { RGL_WIDGET_RESIZE } from '../../AppConstants';
import { faEye, faEyeSlash, faUpDownLeftRight } from '@fortawesome/free-solid-svg-icons';

import styles from './Widget.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type WidgetSize = {
    width: number,
    height: number
}
export type WidgetPosition = {
    w: number,
    h: number,
    x: number,
    y: number
}
export type WidgetItem = {
    gridItem: Layout
    label?: string
    bodySpacing?: number
    node: (size: WidgetSize, setStatus?: (s: boolean) => void, showInfo?: boolean) => ReactNode
    customStyles?: CSSProperties
    headerClassName?: string
    bodyClassName?: string
    isPrimaryHeaderStyle?: boolean
    showStatus?: boolean
    showInfo?: boolean
}
type WidgetProps = {
    children: (size: WidgetSize, setStatus?: (s: boolean) => void, showInfo?: boolean) => ReactNode
    showStatus?: boolean
    showInfo?: boolean
    label?: string
    bodySpacing?: number
    headerClassName?: string
    bodyClassName?: string
    isPrimaryHeaderStyle?: boolean
}

export const Widget: FC<WidgetProps> = (props) => {
    const bodyRef = useRef<HTMLDivElement>(null);
    const [widgetSize, setWidgetSize] = React.useState<WidgetSize>({ width: 0, height: 0 });
    const [status, setStatus] = React.useState<boolean | null>(null);
    const [info, setInfo] = React.useState<boolean>(false);

    const updateContainerSizes = () => {
        if (bodyRef.current) {
            setWidgetSize({ width: bodyRef.current.offsetWidth, height: bodyRef.current.offsetHeight });
        }
    };
    const showInfo = () => {
        setInfo(!info);
    };
    const updateStatus = (newStatus: boolean) => {
        if (status === null && !newStatus) {
            setInfo(true);
        }
        setStatus(newStatus);
    };
    useEffect(() => {
        document.addEventListener(RGL_WIDGET_RESIZE, updateContainerSizes);

        return () => {
            document.removeEventListener(RGL_WIDGET_RESIZE, updateContainerSizes);
        };
    }, []);

    return (
        <div className={styles.container}>
            <div
                className={clsx('js-draggableHandle', styles.header, props.isPrimaryHeaderStyle && styles.primary, props.headerClassName)}>
                {props.label && <div className={styles.label}>{props.showStatus ? <span
                    className={`${styles.status} ${status ? styles.valid : status === null ? styles.null : ''}`}/> : null}{props.label}</div>}
                {props.showInfo &&
                    <div className={styles.info} onClick={showInfo}><FontAwesomeIcon icon={info ? faEye : faEyeSlash}/>
                    </div>}
                <div className={styles.move}>
                    <FontAwesomeIcon icon={faUpDownLeftRight}/>
                </div>
            </div>
            <div className={clsx(`js-draggableCancel`, styles.body, props.bodyClassName)} ref={bodyRef}>
                {props.children(widgetSize, updateStatus, info)}
            </div>
        </div>
    );
};
